/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ShortsInputs */

const en_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shorts`)
};

const es_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalones cortos`)
};

const fr_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shorts`)
};

const de_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shorts`)
};

const ja_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショーツ`)
};

const zh_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短裤`)
};

const ar_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شورتات`)
};

const id_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celana Pendek`)
};

const it_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantaloncini`)
};

const ru_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шорты`)
};

const pt_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shorts`)
};

const ko_val_shorts = /** @type {(inputs: Val_ShortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`반바지`)
};

/**
* | output |
* | --- |
* | "Shorts" |
*
* @param {Val_ShortsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_shorts = /** @type {((inputs?: Val_ShortsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ShortsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_shorts(inputs)
	if (locale === "es") return es_val_shorts(inputs)
	if (locale === "fr") return fr_val_shorts(inputs)
	if (locale === "de") return de_val_shorts(inputs)
	if (locale === "ja") return ja_val_shorts(inputs)
	if (locale === "zh") return zh_val_shorts(inputs)
	if (locale === "ar") return ar_val_shorts(inputs)
	if (locale === "id") return id_val_shorts(inputs)
	if (locale === "it") return it_val_shorts(inputs)
	if (locale === "ru") return ru_val_shorts(inputs)
	if (locale === "pt") return pt_val_shorts(inputs)
	return ko_val_shorts(inputs)
});